module.exports = __webpack_public_path__ + "img/tz1.d0230283.png";